import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNpday70 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_70: Record<
  Exclude<PageIdWoofzNpday70, PageIdWoofzNpday70.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NPDAY_70]: {
    id: PageId.SUBSCRIPTIONS_NPDAY_70,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_NPDAY_70]: {
    id: PageId.CHAT_UPSELL_NPDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NPDAY_70]: {
    id: PageId.UPSELL_NPDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NPDAY_70]: {
    id: PageId.DOWNLOAD_NPDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
